import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { aL as f, t as _, j as t, d as l } from "../../vendor-Dd6qj6gJ.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as c } from "../BaseIcon/index.js";
import { FieldDescription as u } from "../FieldDescription/index.js";
import { FieldError as h } from "../FieldError/index.js";
import { FieldLabel as x } from "../FieldLabel/index.js";
import { Input as F } from "../Input/index.js";
import '../../assets/index43.css';const $ = "_numberField_187b3_1", N = "_label_187b3_13", z = "_fieldControl_187b3_17", C = "_input_187b3_28", W = "_decrement_187b3_34", j = "_increment_187b3_35", v = "_compact_187b3_70", w = "_horizontal_187b3_96", I = "_fullWidth_187b3_115", e = {
  numberField: $,
  label: N,
  fieldControl: z,
  input: C,
  decrement: W,
  increment: j,
  compact: v,
  horizontal: w,
  fullWidth: I
};
function q({
  label: i,
  description: m,
  errorMessage: s,
  horizontal: d = !1,
  fullWidth: a = !1,
  compact: r = !1,
  ...b
}) {
  return /* @__PURE__ */ n(
    f,
    {
      ...p(b),
      className: l(e.numberField, {
        [e.horizontal]: d,
        [e.fullWidth]: a
      }),
      "data-component": "NumberField",
      children: [
        /* @__PURE__ */ o(x, { className: e.label, children: i }),
        /* @__PURE__ */ n(_, { className: l(e.fieldControl, r && e.compact), children: [
          /* @__PURE__ */ o(t, { slot: "decrement", className: e.decrement, children: /* @__PURE__ */ o(c, { icon: r ? "chevron-down" : "remove", size: "xs", color: "moon" }) }),
          /* @__PURE__ */ o(F, { className: e.input }),
          /* @__PURE__ */ o(t, { slot: "increment", className: e.increment, children: /* @__PURE__ */ o(c, { icon: r ? "chevron-up" : "add-new", size: "xs", color: "moon" }) })
        ] }),
        /* @__PURE__ */ o(u, { children: m }),
        /* @__PURE__ */ o(h, { children: s })
      ]
    }
  );
}
export {
  q as NumberField
};
